import React from 'react';
import {t} from 'shared/core';
import {auth, endpoints, types} from 'main/tools';
import {InteractiveTable, Avatar} from 'shared/components';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';

const COLUMNS = [
  {
    header: 'employees.profile.performance.checkins.Cycle Name',
    width: 5,
    attribute: 'cycle.name'
  },
  {
    header: 'employees.profile.performance.checkins.Leader',
    width: 3,
    render: model => <div className='flex'><Avatar employee={model.reviewer} size='sm'/></div>
  },
  {
    header: 'employees.profile.performance.checkins.Days Since Last Check-In',
    width: 4,
    render: model => <FormattedMessage id='employees.profile.performance.checkins.DAYS' values={{numberOfDays: model.daysSinceLastCheckin}}/>
  }
];

const LOCALIZATION = {
  emptyState: 'employees.profile.performance.checkins.No check-ins to display'
};

const checkinPath = (checkin, employee) => {
  if (auth.employee.id === checkin.reviewer.id) return `/performance/reviewees/${employee.id}`;

  return `/performance/cycles/${checkin.cycle.id}/reviewees/${employee.id}`;
};

const CheckinsTable = observer(({employee}) => {
  return (
    <InteractiveTable
      title={t('employees.profile.performance.checkins.Check-Ins')}
      columns={COLUMNS}
      showLinks={false}
      showPath={model => checkinPath(model, employee)}
      proxy={{
        type: 'async',
        endpoint: endpoints.PERFORMANCE.REVIEWERS.with(employee.id),
        modelType: types.PERFORMANCE.CHECKIN_RELATIONS,
        pageSize: 5
      }}
      localization={LOCALIZATION}
    />
  );
});

export default CheckinsTable;
